// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2813fa17b8 _7347054e4d","img":"_13bfb0ba12 _00cd4c75c6"};